function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#E6E6E6"
});

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  mask: "url(#fill-profile_svg__a)"
}, React.createElement("circle", {
  cx: 24,
  cy: 50,
  r: 20,
  fill: "#E6E6E6"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 24,
  cy: 18,
  r: 10,
  fill: "#E6E6E6"
});

var SvgFillProfile = function SvgFillProfile(props) {
  return React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), React.createElement("mask", {
    id: "fill-profile_svg__a",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _ref), _ref2, _ref3);
};

export default "data:image/svg+xml,%3Csvg width='48' height='48' viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cmask id='xnmbyos58a' style='mask-type:alpha' maskUnits='userSpaceOnUse' x='0' y='0' width='48' height='48'%3E %3Ccircle cx='24' cy='24' r='24' fill='%23E6E6E6'/%3E %3C/mask%3E %3Cg mask='url(%23xnmbyos58a)'%3E %3Ccircle cx='24' cy='50' r='20' fill='%23E6E6E6'/%3E %3C/g%3E %3Ccircle cx='24' cy='18' r='10' fill='%23E6E6E6'/%3E %3C/svg%3E";
export { SvgFillProfile as ReactComponent };